import { render } from "./TrashView.vue?vue&type=template&id=b2b19772&scoped=true"
import script from "./TrashView.vue?vue&type=script&lang=js"
export * from "./TrashView.vue?vue&type=script&lang=js"

import "./TrashView.vue?vue&type=style&index=0&id=b2b19772&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_b828ca3935601f9354f53de73adb2d35/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2b19772"]])

export default __exports__